import { stepTextToShow } from "@builder/assist/ui/helpers/wordingHelpers";
import { FadeBetweenContainer } from "@builder/components/general/FadeBetweenContainer/FadeBetweenContainer";
import { useGenerateActivitiesWithMinimalInterval } from "@builder/components/onboard/components/rightSidebar/temporary_fake_activities";
import SlideUp from "@builder/components/onboard/components/slidingElements/SlideUp";
import { AnimatedThreeDots } from "@builder/components/onboard/components/smallComponents/AnimatedThreeDots";
import ThinkingBackground from "@builder/components/onboard/components/thinkingUI/ThinkingBackground";
import { useEffect, useState } from "react";
import "./style.scss";

export const MIN_TIME_TO_ENJOY_PUBLISHING_ANIMATION = 5000;


const someBSBuildTexts: stepTextToShow[] = [
    { present: "Connecting all the pieces", past: "Connected all the pieces" },
    { present: "Publishing your POS", past: "Published your POS" },
];

export const GettinPublished = ({isPromiseFinished}: {isPromiseFinished: boolean}) => {

    const publishingActions = useGenerateActivitiesWithMinimalInterval({ activityArray:someBSBuildTexts, options: {interval: 1200}});
    const [goToCheckmark, setGoToCheckmark] = useState(false);

    useEffect(() => {
        if ((someBSBuildTexts.length === publishingActions.length) && isPromiseFinished) {
            setTimeout(() => {
                setGoToCheckmark(true);
            }, 1500);
        }
    }, [someBSBuildTexts.length, publishingActions.length, isPromiseFinished]);


    return (
        <div className="loading-publish-wrapper">
        <ThinkingBackground>
           <FadeBetweenContainer options={{ fadeDuration: 150, timeInBetween: 300 }}>
                        {goToCheckmark ? (
                            <div className="loading-publish-wrapper" key="checkmark-wrapper">
                                <div className="checkmark">
                                <img src={`/checkmark-once.gif?t=${new Date().getTime()}`} alt="thats-final" key={new Date().getTime()}/>
                                </div>
                            </div>
                        ) : (
                            <SlideUp
                                key="sliding-elements"
                                className="loading-publish-slide-up"
                                items={publishingActions.map((step, idx) => {
                                    const lastOne = idx === publishingActions.length - 1;
                                    return (
                                        {id: idx, element: (
                                        <div key={idx} className="activity">
                                            <AnimatedThreeDots
                                                text={step.present}
                                                numDots={3}
                                                numToFreeze={3}
                                                textClassName="activity-text"
                                                style={{ color: lastOne  ? "#fff" : "#ffffff99" }}
                                            />
                                        </div>
                                        )}
                                    );
                                })}
                                options={{ maxVisibleItems: 5, gap: 24 }}
                            />
                        )}
                    </FadeBetweenContainer>
        </ThinkingBackground>
        </div>
    );
};
